import { DEV_ENVS } from "@constants/globalStrings"

export const isProductionEnv = (): boolean =>
  import.meta.env.REACT_APP_ENV === DEV_ENVS.PROD

export const isDevEnv = (): boolean =>
  import.meta.env.REACT_APP_ENV === DEV_ENVS.DEV

export const isTestEnv = (): boolean => import.meta.env.NODE_ENV === "test"
